import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { LoginCustomizationResolver } from 'src/services';
import { LoginFormComponent } from './login-form/login-form.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { Set2faComponent } from './set-2fa/set-2fa.component';
import { Confirm2faComponent } from './confirm-2fa/confirm-2fa.component';

export const loginRoutes: Routes = [
  {
    path: '',
    component: LoginComponent,
    resolve: {
      loginCustomization: LoginCustomizationResolver,
    },
    children: [
      {
        path: '',
        component: LoginFormComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        resolve: {
          loginCustomization: LoginCustomizationResolver,
        },
      },
      {
        path: 'recovery-password/:token',
        component: RecoveryPasswordComponent,
        resolve: {
          loginCustomization: LoginCustomizationResolver,
        },
      },
      {
        path: '2fa-set/:type/:token',
        component: Set2faComponent,
      },
      {
        path: '2fa-confirm/:type/:token',
        component: Confirm2faComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(loginRoutes)],
})
export class LoginRoutingModule {}
